import { call, put, takeLatest } from "redux-saga/effects";
import { eXetKhoaLuanActionIds, IXetKhoaLuanActionTypeBase, IXetKhoaLuanActionTypes } from "../../action-types/xet-khoa-luan/IXetKhoaLuanActions";
import { xetKhoaLuanApi } from "../../../api/xet-khoa-luan/xetKhoaLuanApi";
import { IXetKhoaLuanRequest } from "../../../model/request/xet-khoa-luan/IXetKhoaLuanRequest";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { danhSachLuanVanApi } from "../../../api/xet-khoa-luan/danhSachLuanVanApi";
import { IDanhSachLuanVanUpdateLockStatusRequest } from "../../../model/request/xet-khoa-luan/IDanhSachLuanVanUpdateLockStatusRequest";
import { IDanhSachThiTotNghiepUpdateLockStatusRequest } from "../../../model/request/xet-khoa-luan/IDanhSachThiTotNghiepUpdateLockStatusRequest";
import { danhSachThiTotNghiepApi } from "../../../api/xet-khoa-luan/danhSachThiTotNghiepApi";
import { rootActions } from "../../actions/rootActions";
import { IXetKhoaLuanSelectByLopRequest } from "../../../model/request/xet-khoa-luan/IXetKhoaLuanSelectByLopRequest";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IIdsRequest } from "../../../model/request/IIdsRequest";


const mainActions = rootActions.xetKhoaLuan;

export function* xetKhoaLuanSaga(): any {
    yield takeLatest(eXetKhoaLuanActionIds.XET_START, xetKhoaLuanWorker);
    yield takeLatest(eXetKhoaLuanActionIds.LOAD_START, selectWorker);
    yield takeLatest(eXetKhoaLuanActionIds.UPDATE_LOCK_STATUS_LUAN_VAN_START, updateLockStatusLuanVanWorker);
    yield takeLatest(eXetKhoaLuanActionIds.CHUYEN_THI_TOT_NGHIEP_START, chuyenThiTotNghiepWorker);
    yield takeLatest(eXetKhoaLuanActionIds.UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_START, updateLockStatusThiTotNghiepWorker);
    yield takeLatest(eXetKhoaLuanActionIds.CHUYEN_LUAN_VAN_START, chuyenLuanVanWorker);
}

function* xetKhoaLuanWorker(action: IXetKhoaLuanActionTypes) : any{
        const request = action.payload as IXetKhoaLuanActionTypeBase<IXetKhoaLuanRequest>;
        const response: IBaseResponse = yield call(xetKhoaLuanApi.XetKhoaLuan, request.data);
        if (response.is_success) {
            yield put(mainActions.XET_SUCCESS({request: request.request, data: undefined}));
        } else {
            yield put(mainActions.XET_ERROR({request: request.request, data: response.message ?? "Không thể thực hiện xét khoá luận"}));
        }
}


function* selectWorker(action: IXetKhoaLuanActionTypes): any {
    const request = action.payload as IXetKhoaLuanActionTypeBase<IXetKhoaLuanSelectByLopRequest>;
    const response: IBaseResponse = yield xetKhoaLuanApi.Select(request.request);
    if (response.is_success) {
        yield put(mainActions.LOAD_SUCCESS({request: request.request, data: {
            danhSachLuanVans: toLowerCaseDeep(response.data.danhSachLuanVans),
            danhSachNoLuanVanThiTotNghieps: toLowerCaseDeep(response.data.danhSachNoLuanVanThiTotNghieps),
             danhSachThiTotNghieps: toLowerCaseDeep(response.data.danhSachThiTotNghieps) }}));
    } else {
        yield put(mainActions.LOAD_ERROR({request: request.request, data: response.message ?? "Không thể tải danh sách luận văn"}));
    }
}

function* updateLockStatusLuanVanWorker(action: IXetKhoaLuanActionTypes): any {
    const request = action.payload as IXetKhoaLuanActionTypeBase<IDanhSachLuanVanUpdateLockStatusRequest>;
    const response: IBaseResponse = yield danhSachLuanVanApi.UpdateLockStatus(request.data);
    if (response.is_success) {
        yield put(mainActions.UPDATE_LOCK_STATUS_LUAN_VAN_SUCCESS({request: request.request, data: undefined}));
    } else {
        yield put(mainActions.UPDATE_LOCK_STATUS_LUAN_VAN_ERROR({request: request.request, data: response.message ?? "Không thể cập nhật trạng thái luận văn"}));
    }
}

function* chuyenThiTotNghiepWorker(action: IXetKhoaLuanActionTypes): any {
    debugger
    const payload = action.payload as IXetKhoaLuanActionTypeBase<IIdsRequest>;
    const request = payload.data;
    const response: IBaseResponse = yield danhSachLuanVanApi.ChuyenThiTotNghiep(request);
    if (response.is_success) {
        yield put(mainActions.CHUYEN_THI_TOT_NGHIEP_SUCCESS({request: payload.request, data: undefined}));
    } else {
        yield put(mainActions.CHUYEN_THI_TOT_NGHIEP_ERROR({request: payload.request, data: response.message ?? "Không thể chuyển thi tốt nghiệp"}));
    }
}


function* updateLockStatusThiTotNghiepWorker(action: IXetKhoaLuanActionTypes): any {
    const request = action.payload as IXetKhoaLuanActionTypeBase<IDanhSachThiTotNghiepUpdateLockStatusRequest>;
    const response: IBaseResponse = yield danhSachThiTotNghiepApi.UpdateLockStatus(request.data);
    if (response.is_success) {
        yield put(mainActions.UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_SUCCESS({request: request.request, data: undefined}));
    } else {
        yield put(mainActions.UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_ERROR({request: request.request, data: response.message ?? "Không thể cập nhật trạng thái thi tốt nghiệp"}));
    }
}

function* chuyenLuanVanWorker(action: IXetKhoaLuanActionTypes): any {
    const payload = action.payload as IXetKhoaLuanActionTypeBase<IIdsRequest>;
    const request = payload.data;
    const response: IBaseResponse = yield danhSachThiTotNghiepApi.ChuyenLuanVan(request);
    if (response.is_success) {
        yield put(mainActions.CHUYEN_LUAN_VAN_SUCCESS({request: payload.request, data: undefined}));
    } else {
        yield put(mainActions.CHUYEN_LUAN_VAN_ERROR({request: payload.request, data: response.message ?? "Không thể chuyển luận văn"}));
    }
}